module.exports = __webpack_public_path__ + "static/media/userLandingScreen.02e96322.svg";